import { useEffect } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';

const MotionActions = ({ setMotionHeaderButtonProps }) => {
  const ctx = useTableContext();
  const { ModalComponent, newButtonText, setShowModal, title } = ctx;

  useEffect(() => {
    if (!!ModalComponent && !!setMotionHeaderButtonProps) {
      setMotionHeaderButtonProps({
        onClick: () => setShowModal(true),
        text: newButtonText || `Add ${title}s`
      });
    }

    return () => {
      setMotionHeaderButtonProps(null);
    };
  }, [ModalComponent, setMotionHeaderButtonProps]);

  return null;
};

export default MotionActions;
